import axios, { type AxiosResponse } from "axios";
import { OnboardingItemSchema } from "@/schemas/index";
import type { OnboardingItemType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceOnboardingApiType {
  fetchOnboarding: () => Promise<OnboardingItemType[]>;
}

export const serviceOnboardingApi: ServiceOnboardingApiType = {
  fetchOnboarding: () => {
    return axios
      .get(`${env.services.portal}/onboarding`)
      .then((response: AxiosResponse<unknown[]>) => {
        return response?.data?.map((data: unknown) =>
          OnboardingItemSchema.parse(data || {}),
        );
      });
  },
};
